/* src/app/client/client.component.scss */
.mat-mdc-cell {
  text-align: left;
}
.mat-mdc-row {
  border-color: #605959;
}
a:hover {
  cursor: pointer;
}
a:not([href]):not([tabeindex]) {
  text-decoration: underline;
}
.my-buttons > div:nth-child(3) {
  width: 55%;
}
.mat-mdc-row:hover {
  background-color: darkgray;
  color: black;
}
.mat-mdc-row:hover .toolbar {
  visibility: visible;
}
.menu {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding-top: 20px;
}
.menu input {
  line-height: 2rem;
}
.menu button {
  margin-left: 10px;
}
.menu div {
  margin-left: 20px;
}
.mat-column-parent_name {
  padding: 0 20px 0 20px;
  flex: 2;
}
.mat-column-name {
  flex: 2;
}
.mat-column-tag_count {
  flex: 1 1 200px !important;
  justify-content: flex-start;
  overflow: visible !important;
}
.tag-inline-container {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
}
.tag-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  background: #E8F5E9;
  color: black;
  white-space: nowrap;
}
.tag-overflow-container {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.tag-overflow-badge {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 6px 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  background: #E8F5E9;
  color: black;
  cursor: default;
  white-space: nowrap;
}
.tag-overflow-icon {
  font-size: 12px !important;
  width: 12px !important;
  height: 12px !important;
  line-height: 12px !important;
}
.tag-popup {
  position: absolute;
  bottom: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 4px 0;
  min-width: 120px;
  white-space: nowrap;
}
.tag-popup-item {
  padding: 4px 12px;
  font-size: 13px;
  color: #333;
}
.mat-column-user_count {
  flex: 0 0 80px !important;
  justify-content: right;
  padding-right: 10px;
  cursor: pointer;
}
.mat-column-code_count {
  flex: 0 0 80px !important;
  justify-content: center;
  padding-right: 10px;
  cursor: pointer;
}
.mat-column-kind {
  flex: 0 0 120px !important;
  max-width: 120px !important;
}
.mat-column-toolbar {
  flex: 4;
}
.mat-column-contract_start {
  flex: 0 0 120px !important;
  max-width: 120px;
}
.mat-column-contract_end {
  flex: 0 0 120px !important;
  max-width: 120px;
}
.column-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  margin-left: 5px;
  color: #777;
}
.column-icon.key-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.column-icon.family-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.toolbar {
  display: flex;
}
.no-parent-label {
  color: #999;
}
.toolbar a {
  padding: 6px 12px;
  font-size: 14px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  transition: background-color 0.2s;
  border-right: 1px solid #CCC;
}
.toolbar a:first-child {
  border-radius: 4px 0 0 4px;
}
.toolbar a:last-child {
  border-radius: 0 4px 4px 0;
  border-right: none;
}
.toolbar a:hover {
  background-color: #0056b3;
}
.mat-checkbox {
  margin-left: 10px;
  padding-top: 6px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
.modal-content-wrapper {
  background-color: transparent;
  padding: 0;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  border: none;
  width: 800px;
}
.mat-mdc-row {
  position: relative !important;
}
.mat-mdc-cell {
  align-self: center;
}
.mat-column-actions {
  flex: 0 0 60px !important;
  display: flex !important;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px !important;
  overflow: visible !important;
}
.action-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-trigger {
  opacity: 0;
  transition: opacity 0.2s;
  background: transparent !important;
  border: none !important;
  outline: none !important;
  padding: 0 !important;
  min-width: unset !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.menu-trigger .mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #757575;
}
.menu-trigger:hover,
.menu-trigger.active {
  background-color: rgba(0, 0, 0, 0.04) !important;
  opacity: 1 !important;
}
.menu-trigger {
  text-decoration: none !important;
}
.mat-mdc-row:hover .menu-trigger {
  opacity: 1;
}
.row-toolbar {
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 5px 0;
  min-width: 140px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-50%) scale(0.95);
  transition:
    opacity 0.25s ease,
    transform 0.25s ease,
    visibility 0s linear 0.25s;
}
.row-toolbar.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) scale(1);
  transition-delay: 0s;
}
.row-toolbar.visible .action-btn {
  opacity: 1;
  transition: opacity 0.25s ease;
}
.tag-filter-area {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-left: 12px;
}
.selected-tag-chip {
  display: inline-flex;
  align-items: center;
  background: #E8F5E9;
  color: black;
  border-radius: 12px;
  padding: 3px 8px 3px 10px;
  font-size: 13px;
  gap: 5px;
  white-space: nowrap;
}
.chip-remove {
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  opacity: 0.8;
}
.chip-remove:hover {
  opacity: 1;
}
.filter-input-container {
  position: relative;
}
.filter-input-container .tag-suggestion-dropdown,
.filter-input-container .tag-suggestion-item {
  margin-left: 0;
}
.tag-suggestion-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  min-width: 200px;
  padding: 4px 0;
}
.tag-suggestion-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
  color: #333;
}
.tag-suggestion-item:hover {
  background: #f5f5f5;
}
.tag-suggestion-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #666;
}
.mat-column-select {
  flex: 0 0 48px !important;
  max-width: 48px !important;
  justify-content: center;
  padding: 0 8px !important;
}
.bulk-actions-area {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto !important;
}
.selection-count {
  font-size: 13px;
  color: #666;
  white-space: nowrap;
}
.bulk-actions-container {
  position: relative;
  margin-left: 0 !important;
}
.bulk-actions-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 1px solid #d0d0d0;
  background: white;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  color: #333;
}
.bulk-actions-btn:hover {
  background: #f5f5f5;
}
.bulk-actions-btn .bulk-chevron {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.bulk-actions-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: white;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  z-index: 1002;
  min-width: 170px;
  padding: 4px 0;
}
.bulk-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  font-size: 13px;
  cursor: pointer;
  color: #333;
}
.bulk-menu-item:hover {
  background: #fafafa;
}
.bulk-menu-item .bulk-menu-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #666;
}
.bulk-menu-item.bulk-menu-item-disabled {
  color: #aaa;
  cursor: default;
}
.bulk-menu-item.bulk-menu-item-disabled:hover {
  background: none;
}
.bulk-menu-item.bulk-menu-item-disabled .bulk-menu-icon {
  color: #bbb;
}
.action-btn {
  display: block;
  padding: 8px 16px;
  background-color: transparent;
  border: none;
  font-size: 13px;
  color: #333 !important;
  text-decoration: none !important;
  cursor: pointer;
  white-space: nowrap;
  text-align: left;
  line-height: normal;
  opacity: 0;
  transition: opacity 0.1s ease;
}
.action-btn:hover {
  background-color: #f5f5f5;
  color: black !important;
}
.action-btn {
  margin: 0;
  border-bottom: none;
  border-radius: 0;
}
/*# sourceMappingURL=client.component.css.map */
